import React from 'react';
import { Link } from 'react-router-dom';
import './DonationBanner.css';

const AboutDonationBanner = () => {
  return (
    <section
      id="donate-section"
      className="donation-banner"
    >
      <div className="banner-overlay"></div>
      <div className="container">
        <div className="banner-content fade-up">
          <h2>Help Us Make a Difference</h2>
          <p>Your contribution can change lives. Join us in our mission to create a better world.</p>
          <Link to="/donation" className="btn btn-primary pulse">
            Donate Now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutDonationBanner;
